import Footer from './index.vue'
export default Footer
